var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('h1',{staticClass:"mb-4"},[_vm._v("Web Search")]),_c('v-card',[_c('v-card-title',[_vm._v("Intelligent Search")]),_c('v-divider'),_c('v-card-text',[_c('WebSearch')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }